<template>
  <div class="box" id="csDIV" :style="'background:url(' + bg + ') no-repeat;'">
    <!-- 内容主区域 -->
    <div class="content">
      <!-- 标题 -->
      <div style="padding-bottom: 60px;">
        <!-- 英文图片 -->
        <!-- <img :src="logoName" alt=""> -->
        <!-- 中文图片 -->
        <img :src="logoNameZh" alt="">
      </div>
      <!-- 切换中英文 -->
      <div class="content-title">
        <!-- 中文 -->
        <span>{{ loginChina }}</span>
        <span>/</span>
        <!-- <span @click="changeLang(lange)" class="language">{{loginEnglish}}</span> -->
        <!-- <span @click="changeLang(lange)" class="language">{{loginEnglish}}</span> -->
        <span class="language">{{ loginEnglish }}</span>
        <!-- 英文 -->
      </div>
      <ul class="login-input">
        <li style="position: relative;">
          <input type="text" class="text" id="username" v-model="loginForm.username" :placeholder="$t('common.userName')"
            @mouseout="nameshow = false" @mouseover="focusName()" required autocomplete="off" @keydown.enter="fun()">
          <i class="el-input__icon el-icon-circle-close el-input__clear" style="position: absolute;
    right: 30px;
    color: #dfdfdf;cursor: pointer;" :title="$t('common.clear')" v-show="nameshow" @mouseover="focusName()"
            @click="loginForm.username = ''"></i>
        </li>
        <li style="position: relative;">
          <input type="password" class="text" id="password" v-model="password" :placeholder="$t('common.passWord')"
            @mouseout="passshow = false" @mouseover="focusPass()" required @keydown.enter="fun()">
          <i class="el-input__icon el-icon-circle-close el-input__clear" style="position: absolute;
    right: 30px;
    color: #dfdfdf;cursor: po inter;" :title="$t('common.clear')" v-show="passshow" @mouseover="focusPass()"
            @click="password = ''"></i>
        </li>
        <li style="position: relative;">
          <input type="text" name="captcha" id="captcha" v-model="loginForm.captcha" :placeholder="$t('common.code')"
            autocomplete="off" class="text" @keydown.enter="fun()">
          <img :src="confimcaptcha" @click="getUserCode" style="padding: 0px 0px 0px 0px;
             color: #889aa4;
             vertical-align: middle;
             width: 80px;
             display: inline-block;position: absolute;
    right: 40px;
    top: 5px;">
        </li>
      </ul>
      <!-- 登录按钮 -->
      <div style="text-align: center;padding-bottom: 20px;">
        <!-- <button type="" id="submitButton" class="btn" @click="loginInfo">G&nbsp;O</button> -->
        <button type="" id="submitButton" class="btn" @click="fun()">G&nbsp;O</button>
      </div>
      <!-- 忘记密码 -->
      <div style="text-align: center;color:#ffffff;opacity: .35;height:20px;">
        <span class="modify">{{ $t('common.forget') }}</span>
      </div>
      <div class="footer">
        <span @click="platform">{{ $t('common.platform') }}
          <i style="width: 2px;height: 16px;background: #cccccc;display: inline-block;margin: 0px 13px -4px 13px;"></i>
        </span>
        <!-- <span @click="docking">{{ $t('common.docking') }}
          <i style="width: 2px;height: 16px;background: #cccccc;display: inline-block;margin: 0px 13px -4px 13px;"></i>
        </span> -->
        <span @click="fireHref">App下载
        </span>
        <!-- <span @click="appHref">{{$t('common.app')}}
      </span> -->
      </div>
    </div>
    <!-- 首次登录修改密码 -->
    <div class="dialog" v-show="dialogPassWord">
    </div>
    <transition name="slide-right">
      <div v-show="dialogPassWord" class="dialog-style" style="z-index: 11;">
        <div class="dialog-header">
          <div
            style="font-size: 14px;font-weight: bold;font-stretch: normal;line-height: 28px;letter-spacing: 0px;color: #666666;padding-left: 20px;">
            <span>{{ $t('common.firstLogin') }}</span>
          </div>
          <div style="flex: 1;text-align: right;padding-right: 20px;padding-top: 5px;">
            <i class="el-icon-close" style="margin-left: 20px;cursor: pointer;" @click="closeDialogInfo"></i>
          </div>
        </div>
        <div class="dialog-content">
          <el-form :model="passForm" size="small" :rules="rules" ref="passForm" label-width="160px" class="demo-passForm">
            <el-form-item :label="$t('common.loginName')" prop="loginAccount">
              <el-input v-model.number="passForm.loginAccount" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('common.newPass')" prop="password">
              <el-input type="password" v-model="passForm.password" clearable autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$t('common.confirmpass')" prop="checkPass">
              <el-input type="password" v-model="passForm.checkPass" clearable autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm()">{{ $t('common.edit') }}</el-button>
              <el-button @click="resetForm()">{{ $t('common.cancel') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </transition>
    <!-- 选择联网单位 -->
    <div class="dialog" v-show="projectDialog">
    </div>
    <transition name="slide-right">
      <div v-show="projectDialog" class="dialog-style1" style="z-index: 11;">
        <div class="dialog-header">
          <div
            style="font-size: 14px;font-weight: bold;font-stretch: normal;line-height: 28px;letter-spacing: 0px;color: #666666;padding-left: 20px;">
            <span>{{ $t('common.choiceUnit') }}</span>
          </div>
          <div style="flex: 1;text-align: right;padding-right: 20px;padding-top: 5px;">
            <i class="el-icon-close" style="margin-left: 20px;cursor: pointer;" @click="closeDialogProjectInfo"></i>
          </div>
        </div>
        <div class="dialog-content1">
          <div>
            <el-input size="small" :placeholder="$t('common.nameTips')" clearable v-model="inputValue" class="border15"
              @clear="searchInfo" style="width:450px;margin-right:20px;">
              <el-button slot="append" icon="el-icon-search" @click="searchInfo"></el-button>
            </el-input>
          </div>
          <ul class="projectul">
            <li @click="changeProject('0')" style="color:#ff6f61;font-weight:bold">
              {{ $t('common.all') }}<span style="font-size: 12px;">{{ $t('common.allSearch') }}</span>
            </li>
            <li v-for="item in tableData" v-bind:key="item.id" @click="changeProject(item.id)">
              {{ item.projectName }}
            </li>
          </ul>
          <div class="page-list2">
            <div class="page-action">
              <ul class="page-number2">
                <!-- 首页 -->
                <li v-if="pageIndexPro > 1">
                  <i class="el-icon-d-arrow-left" v-on:click="pageClickPro(1)"></i>
                </li>
                <li v-if="pageIndexPro === 1">
                  <i class="el-icon-d-arrow-left" style="color: #cccccc;cursor: not-allowed;"></i>
                </li>
                <!-- 上一页 -->
                <li v-if="pageIndexPro > 1">
                  <i class="el-icon-arrow-left" v-on:click="pageIndexPro--, pageClickPro(pageIndexPro)"></i>
                </li>
                <li v-if="pageIndexPro === 1">
                  <i class="el-icon-arrow-left" style="color: #cccccc;cursor: not-allowed;"></i>
                </li>
                <li>
                  <span style="font-size: 14px;">{{ pageIndexPro }}</span>
                </li>
                <!-- 下一页 -->
                <li v-if="pageIndexPro !== totalPagePro">
                  <i class="el-icon-arrow-right" v-on:click="pageIndexPro++, pageClickPro(pageIndexPro)"></i>
                </li>
                <li v-if="pageIndexPro === totalPagePro">
                  <i class="el-icon-arrow-right" style="color: #cccccc;cursor: not-allowed;"></i>
                </li>
                <!-- 尾页 -->
                <li v-if="pageIndexPro !== totalPagePro">
                  <i class="el-icon-d-arrow-right" v-on:click="pageIndexPro++, pageClickPro(totalPagePro)"></i>
                </li>
                <li v-if="pageIndexPro === totalPagePro">
                  <i class="el-icon-arrow-right" style="color: #cccccc;cursor: not-allowed;"></i>
                </li>
                <li>
                  <span style="font-size: 14px;">共{{ totalPagePro }}页</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <p class="footer-Copyright">Copyright © 2025 镇江中消云物联网科技有限公司
      <span class="link-beian" @click="linkBeian(1)"> 苏ICP备2024151342号-1</span>
      <!-- <span class="link-beian"
            @click="linkBeian(2)"> <img src="@/assets/beian-icon.png"
             alt=""> 京公网安备 11011302005311号</span> -->
      <!-- <span class="link-beian">投诉电话：010-65009696</span> -->
    </p>
    <p class="footer-bottom">
      <span>投诉电话：18652424678</span>
    </p>
  </div>
</template>

<script>
import setCookie from '../utilits'
import {
  getToken,
  getCode,
  loginByUsername,
  updateUserPassword,
  getSystemProjectList,
  getUserPassword
} from '@/api/common'
import md5 from 'md5'
// import Cookies from 'js-cookie'
import { baseUrl } from '@/config/env'
export default {
  name: 'HelloWorld',
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('common.passTips')))
      } else {
        if (this.passForm.checkPass !== '') {
          this.$refs.passForm.validateField('checkPass')
        }
        if (value.indexOf(this.loginForm.username) !== -1) {
          callback(new Error(this.$t('common.indexofuserName')))
        }
        if (md5(value) === this.oldPassword) {
          callback(new Error(this.$t('common.samePass')))
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('common.passTipsAgain')))
      } else if (value !== this.passForm.password) {
        callback(new Error(this.$t('common.passTwice')))
      } else {
        callback()
      }
    }
    return {
      inputValue: '',
      pageSizePro: 10,
      // 页码
      pageIndexPro: 1,
      // 总total
      totalRecordsPro: 0,
      // 总页数
      totalPagePro: 0,
      // lange: Cookies.get('language') || 'zh',
      lange: 'zh',
      loginChina: '单位登录',
      loginEnglish: 'USER LOGIN',
      baseUrl,
      logoName: require('../assets/SmartFireCloudPlatform.png'),
      logoNameZh: require('../assets/SmartFireZh-danyang.png'),
      bg: require('../assets/BG.png'),
      code: {
        width: 80,
        height: 34,
        type: 'login',
        codeCount: 4,
        fontSize: 24,
        lineCount: 30,
        codeType: 'nl',
        rnd: Math.random()
      },
      password: '',
      loginForm: {
        username: '',
        password: '',
        captcha: ''
      },
      // 修改密码弹窗
      dialogPassWord: false,
      passForm: {
        loginAccount: '',
        password: '',
        checkPass: ''
      },
      confimcaptcha: '',
      projectDialog: false,
      tableData: [],
      nameshow: false,
      passshow: false,
      projectName: '',
      privacyAgreementData: '',
      oldPassword: '',
      rules: {
        password: [
          { pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\\\W_!@#$%^&*`~()-+=.,;<>:]+$)(?![a-z0-9]+$)(?![a-z\\\\W_!@#$%^&*`~()-+=.,;<>:]+$)(?![0-9\\\\W_!@#$%^&*`~()-+=.,;<>:]+$)[a-zA-Z0-9\\\\W_!@#$%^&*`~()-+=.,;<>:]{8,15}$/, message: this.$t('common.passTips615') },
          { validator: validatePass, trigger: 'blur', required: true }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur', required: true }
        ]
      },
      clientWidth: document.body.clientWidth
    }
  },
  components: {
  },
  watch: {
    'loginForm.username': {
      handler: function (val, oldValue) {
        if (this.loginForm.username === '') {
          this.nameshow = false
        } else {
          this.nameshow = true
        }
      },
      deep: true
    },
    password: {
      handler: function (val, oldValue) {
        if (this.password === '') {
          this.passshow = false
        } else {
          this.passshow = true
        }
      },
      deep: true
    },
    projectDialog: {
      handler: function (newVal, oldValue) {
        if (newVal) {
          console.log(11)
          let input = document.getElementById('captcha')
          input.blur()
        }
      },
      deep: true
    }
  },
  created() {
    this.langs()
    // 获取token
    this.getToken()
    // window.location.href = baseUrl
  },
  methods: {
    // 跳转备案
    linkBeian(type) {
      if (type === 1) {
        window.open('https://beian.miit.gov.cn')
      } else {
        window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011302005311')
      }
    },
    // 判断使用语言
    langs() {
      // 判断有没有缓存
      if (localStorage.getItem('zxylanguage')) {
        if (localStorage.getItem('zxylanguage') === 'zh') {
          setCookie('language', 'zh')
        } else {
          setCookie('language', 'en')
          // Cookies.set('language', 'zh')
        }
      } else {
        // 判断浏览器语言 if中文则是zh，否则是en
        if ((navigator.language || navigator.browserLanguage).toLowerCase().substring(0, 2) === 'zh') {
          this.lange = 'zh'
        } else {
          // 先把中英文切换禁用
          // this.lange = 'en'
          this.lange = 'zh'
        }
        localStorage.setItem('zxylanguage', this.lange)
        setCookie('language', this.lange)
        this.$i18n.locale = localStorage.getItem('zxylanguage')
      }
      if (this.lange === 'en') {
        this.loginChina = 'USER LOGIN'
        this.loginEnglish = '单位登录'
      } else {
        this.loginChina = '单位登录'
        this.loginEnglish = 'USER LOGIN'
      }
    },
    // 中英文文字切换
    changeLang(val) {
      console.log(val)
      if (val === 'en') {
        this.loginChina = '单位登录'
        this.loginEnglish = 'USER LOGIN'
        this.lange = 'zh'
        localStorage.setItem('zxylanguage', 'zh')
        setCookie('language', 'zh')
      } else {
        this.loginChina = 'USER LOGIN'
        this.loginEnglish = '单位登录'
        this.lange = 'en'
        localStorage.setItem('zxylanguage', 'en')
        setCookie('language', 'en')
      }
      this.$i18n.locale = localStorage.getItem('zxylanguage')
    },
    fun() {
      if (this.loginForm.username === '') {
        this.$message({
          message: this.$t('common.usernameT'),
          type: 'error',
          duration: 2 * 1000
        })
      } else if (this.password === '') {
        this.$message({
          message: this.$t('common.passT'),
          type: 'error',
          duration: 2 * 1000
        })
      } else if (this.loginForm.captcha === '') {
        this.$message({
          message: this.$t('common.captchaT'),
          type: 'error',
          duration: 2 * 1000
        })
      } else {
        this.loginInfo()
      }
      // const DOM = event.target.parentNode
      // const nextDOM = DOM.nextElementSibling.children[0]
      // DOM.blur()
      // nextDOM.focus()
    },
    getToken() {
      getToken()
        .then(response => {
          if (response.code === '000000') {
            sessionStorage.clear()
            let th = this
            setTimeout(() => {
              th.getUserCode()
            }, 500)
            // this.getUserCode()
          } else {
            this.$message({
              message: response.message,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getUserCode() {
      getCode(this.code).then(response => {
        return 'data:image/png;base64,' + btoa(
          new Uint8Array(response)
            .reduce((data, byte) => data + String.fromCharCode(byte), '')
        )
      }).then(data => {
        this.confimcaptcha = data
      }).catch(err => {
        // alert('cuowu')
        console.log(err)
      })
    },
    loginInfo() {
      this.loginForm.password = md5(this.password)
      loginByUsername(this.loginForm)
        .then(response => {
          if (response.code === '000000') {
            // 判断新闻公告
            sessionStorage.setItem('callApi', 1)
            sessionStorage.setItem('moduleCode', 3)
            // 是否首次登录if 1需要修改密码
            this.privacyAgreementData = response.data.privacyAgreement
            if (response.data.roleCode === 97) {
              if (this.clientWidth >= 2500) {
                window.location.href = baseUrl + '/yzcScreen.html#/'
              } else {
                window.location.href = baseUrl + '/moreScreen.html#/'
              }
            } else {
              if (response.data.isChangePassword === 1) {
                this.dialogPassWord = true
                // 调取现有的密码
                this.getUserPassword()
                this.passForm.loginAccount = this.loginForm.username
              } else {
                if (response.data.projectCount === 0) {
                  this.$message({
                    message: this.$t('common.useTips'),
                    type: 'error',
                    duration: 2 * 1000
                  })
                } else if (response.data.projectCount === 1) {
                  this.getSystemProjectList()
                  // window.location.href = baseUrl + '/business.html#/ProjectHome'
                } else {
                  // 弹出选择项目框
                  this.projectDialog = true
                  // 调用项目列表接口
                  this.getSystemProjectList()
                }
              }
            }
            // else {
            //   if (this.privacyAgreementData === 1) {
            //     this.privacyAgreementData = response.data.privacyAgreement
            //     this.routerModuleCode = response.data.moduleCode
            //     this.$router.push({name: 'Disclaimer', params: {reset: this.routerModuleCode}})
            //     sessionStorage.setItem('moduleCode', response.data.moduleCode)
            //   } else {
            //     if (response.data.projectCount === 0) {
            //       this.$message({
            //         message: this.$t('common.useTips'),
            //         type: 'error',
            //         duration: 2 * 1000
            //       })
            //     } else if (response.data.projectCount === 1) {
            //       sessionStorage.setItem('moduleCode', response.data.moduleCode)
            //       this.getSystemProjectList()
            //       // window.location.href = baseUrl + '/business.html#/ProjectHome'
            //     } else {
            //       // 弹出选择项目框
            //       this.projectDialog = true
            //       // 调用项目列表接口
            //       this.getSystemProjectList()
            //     }
            //   }
            // }
          } else if (response.code === 'P03001') {
            this.$message({
              message: response.message,
              type: 'error',
              duration: 5 * 1000
            })
            this.loginForm.captcha = ''
            // this.getUserCode()
            let th = this
            setTimeout(() => {
              th.getUserCode()
            }, 500)
          } else {
            this.$message({
              message: response.message,
              type: 'error',
              duration: 2 * 1000
            })
            let th = this
            setTimeout(() => {
              th.loginForm.captcha = ''
              th.getUserCode()
            }, 500)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取密码
    getUserPassword() {
      getUserPassword().then(response => {
        if (response.code === '000000') {
          this.oldPassword = response.data
        } else {
          this.$message({
            message: response.message,
            type: 'error',
            duration: 5 * 1000
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    closeDialogInfo() {
      this.$confirm(this.$t('common.forSecurity'), 'Tips', {
        type: 'warning'
      }).then(() => {
        this.dialogPassWord = false
        this.passForm.password = ''
        this.passForm.checkPass = ''
      })
    },
    submitForm() {
      this.$refs.passForm.validate(valid => {
        if (valid) {
          updateUserPassword({
            password: md5(this.passForm.password)
          }).then(response => {
            if (response.code === '000000') {
              sessionStorage.setItem('callApi', 1)
              sessionStorage.setItem('moduleCode', 3)
              this.dialogPassWord = false
              this.passForm.password = ''
              this.passForm.checkPass = ''
              if (response.data.roleCode === 97) {
                if (this.clientWidth >= 2500) {
                  window.location.href = baseUrl + '/yzcScreen.html#/'
                } else {
                  window.location.href = baseUrl + '/moreScreen.html#/'
                }
              } else {
                if (response.data.projectCount === 0) {
                  this.$message({
                    message: this.$t('common.useTips'),
                    type: 'error',
                    duration: 2 * 1000
                  })
                } else if (response.data.projectCount === 1) {
                  this.getSystemProjectList()
                  // window.location.href = baseUrl + '/business.html#/ProjectHome'
                } else {
                  // 弹出选择项目框
                  this.projectDialog = true
                  // 调用项目列表接口
                  this.getSystemProjectList()
                }
              }
            } else {
              this.$message({
                message: response.message,
                type: 'error',
                duration: 2 * 1000
              })
            }
          }).catch(err => {
            console.log(err)
          })
        } else {
          this.$message({
            message: this.$t('common.allTip'),
            type: 'error',
            duration: 5 * 1000
          })
          return false
        }
      })
    },
    resetForm() {
      this.dialogPassWord = false
      this.passForm.password = ''
      this.passForm.checkPass = ''
    },
    closeDialogProjectInfo() {
      this.projectDialog = false
      this.projectName = ''
      this.inputValue = ''
      this.pageIndexPro = 1
      this.pageSizePro = 10
    },
    pageClickPro(val) {
      this.pageIndexPro = val
      this.getSystemProjectList()
    },
    /* eslint-disable*/
    // 判断身份，判断项目个数
    getSystemProjectList() {
      getSystemProjectList({
        'projectName': this.projectName,
        'pageIndex': this.pageIndexPro,
        'pageSize': this.pageSizePro
      }).then(response => {
        if (response.code === '000000') {
          this.tableData = []
          response.data.forEach(item => {
            const datas = {}
            datas.projectName = item.projectName
            datas.id = item.id
            this.tableData.push(datas)
          })
          // this.totalPagePro = response.totalPages
          if (response.totalPages === 0) {
            this.totalPagePro = 1
          } else {
            this.totalPagePro = response.totalPages
          }
          if (this.projectName === '') {
            if (response.totalRecords === 1) {
              if (this.privacyAgreementData === 1) {
                sessionStorage.setItem('projectId', this.tableData[0].id)
                this.$router.push({ name: 'Disclaimer', params: { reset: 3 } })
              } else {
                sessionStorage.setItem('projectId', this.tableData[0].id)
                window.location.href = baseUrl + '/business.html#/ProjectHome'
              }
            }
          }
          // this.tableData = response.data
          // this.totalRecords = response.totalRecords
          // if (this.projectName === '') {
          //   if (this.tableData.length === 1) {
          //     if (this.privacyAgreementData === 1) {
          //       sessionStorage.setItem('moduleCode', 3)
          //       sessionStorage.setItem('projectId', this.tableData[0].id)
          //       this.$router.push({name: 'Disclaimer', params: {reset: 3}})
          //     } else {
          //       sessionStorage.setItem('projectId', this.tableData[0].id)
          //       window.location.href = baseUrl + '/business.html#/ProjectHome'
          //     }
          //   }
          // }
        } else {
          this.$message({
            message: response.message,
            type: 'error',
            duration: 5 * 1000
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    changeProject(id) {
      if (id === '0') {
        if (this.privacyAgreementData === 1) {
          this.$router.push({ name: 'Disclaimer', params: { reset: 3 } })
        } else {
          window.location.href = baseUrl + '/business.html#/home'
        }
      } else {
        if (this.privacyAgreementData === 1) {
          sessionStorage.setItem('projectId', id)
          this.$router.push({ name: 'Disclaimer', params: { reset: this.routerModuleCode } })
        } else {
          sessionStorage.setItem('projectId', id)
          window.location.href = baseUrl + '/business.html#/ProjectHome'
        }
      }
    },
    // 显示名字清除
    focusName() {
      if (this.loginForm.username === '') {
        this.nameshow = false
      } else {
        this.nameshow = true
      }
    },
    // 显示密码清除
    focusPass() {
      if (this.password === '') {
        this.passshow = false
      } else {
        this.passshow = true
      }
    },
    searchInfo() {
      this.projectName = this.inputValue
      this.pageIndexPro = 1
      this.getSystemProjectList()
    },
    // 跳转
    platform() {
      window.open('https://www.24h119.com//static/api.pdf')
    },
    docking() {
      window.location.href = 'https://zxyun119.com/third/智慧消防云平台协议对接申请表.doc'
    },
    fireHref() {
      window.open(baseUrl + '/download.html')
    },
    appHref() {
      window.open(baseUrl + '/hzyzs-app/index.html')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  height: 65%;
}

.footer-Copyright {
  position: absolute;
  left: 0;
  bottom: 70px;
  right: 0;
  margin: auto;
  font-size: 12px;
  color: #ffffff;
  /* width: 600px; */
  text-align: center;
}

.footer-bottom {
  position: absolute;
  left: 0;
  bottom: 30px;
  right: 0;
  margin: auto;
  font-size: 12px;
  color: #ffffff;
  /* width: 600px; */
  text-align: center;
}

.link-beian {
  cursor: pointer;
  margin-left: 10px;
}

.link-beian img {
  /* width: 15px; */
  vertical-align: text-bottom;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue